<template>
<div class="arrival-admin">
    <div class="title">
        延期管理
    </div>
    
    <!-- tab切换 -->
    <div class="tab-header">
        <!-- <div 
            class="tab-item" 
            :class="{ active: tabState === 'urge' }" 
            @click="switchTab('urge')"
        >
            催交列表
        </div> -->
        <div 
            class="tab-item" 
            :class="{ active: tabState === 'deferred' }" 
            @click="switchTab('deferred')"
        >
            延期列表
        </div>
    </div>
    
    <!-- 搜索框 -->
    <div class="search-box">
        <el-form :inline="true" :model="searchData" size="mini">
            <el-form-item label="企业名" v-if="tabState === 'urge'">
                <el-input v-model="searchData.store_name" placeholder="请输入企业名" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产编码">
                <el-input v-model="searchData.sccode" placeholder="生产编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="OE号">
                <el-input v-model="searchData.oecode" placeholder="OE号" clearable></el-input>
            </el-form-item>
            <el-form-item >
              
                <el-button type="primary" @click="onSubmit">搜索</el-button>
                <el-button @click="clearSearch">清空</el-button>
            </el-form-item>
            <el-form-item style="float: right;">
                <el-button type="warning" @click="showBatchEdit">批量修改</el-button>
                <el-button type="success" @click="showUploadModal">上传修改</el-button>
                <el-button type="success" @click="handleExport">导出</el-button>
               
            </el-form-item>
        </el-form>
    </div>
    
    <div class="urge-table">
        <div class="table-head">
            <div class="checkbox">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
            </div>
            <div class="index">序号</div>
            <div class="member_name" v-if="tabState === 'urge'">用户名</div>
            <div class="store_name" v-if="tabState === 'urge'">企业名</div>
            <div class="goods_name">配件名称</div>
            <div class="sccode">生产编码</div>
            <div class="oecode">OE号</div>
            <div class="oenaturebrand">品牌</div>
            <div class="add_time" v-if="tabState === 'urge'">催交时间</div>
            <div class="add_time">上海到货时间</div>
            <div class="add_time">丹阳到货时间</div>
        </div>
        <div class="table-body">
            <div class="table-row" v-for="(item, index) in urgeList" :key="index">
                <div class="checkbox">
                    <el-checkbox v-model="item.checked" @change="handleItemCheck"></el-checkbox>
                </div>
                <div class="index">{{ index + 1 }}</div>
                <div class="member_name" v-if="tabState === 'urge'">{{ item.member_name }}</div>
                <div class="store_name" v-if="tabState === 'urge'">{{ item.new_store_name }}</div>
                <div class="goods_name" :title="item.goods_name">{{ item.goods_name }}</div>
                <div class="sccode">{{ item.sccode }}</div>
                <div class="oecode">{{ item.oecode }}</div>
                <div class="oenaturebrand">{{ item.oenaturebrand }}</div>
                
                <div class="add_time" v-if="tabState === 'urge'">{{ $hnwTools.formatDateTime(item.addtime) }}</div>
                <div class="add_time">
                    <el-date-picker 
                        v-model="item.book_down_time" 
                        type="datetime"
                        size="mini" 
                        placeholder="选择上海到货时间"
                        @blur="handleBookDownTimeBlur(item)"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </div>
                <div class="add_time">
                    <el-date-picker 
                        v-model="item.delivery_time" 
                        type="datetime"
                        size="mini" 
                        placeholder="选择丹阳到货时间"
                        @blur="handleDeliveryTimeBlur(item)"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </div>
            </div>
            <div v-if="urgeList.length === 0" class="no-data">
                暂无数据
            </div>
        </div>
    </div>
    
    <div class="pagination-box" v-if="total > 0">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
    
    <!-- 批量修改弹窗 -->
    <el-dialog title="批量修改" :visible.sync="batchEditVisible" width="400px">
        <el-form :model="batchForm" label-width="120px">
            <el-form-item label="上海到货时间">
                <el-date-picker 
                    v-model="batchForm.book_down_time" 
                    type="datetime" 
                    placeholder="选择上海到货时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="丹阳到货时间">
                <el-date-picker 
                    v-model="batchForm.delivery_time" 
                    type="datetime" 
                    placeholder="选择丹阳到货时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="batchEditVisible = false">取消</el-button>
            <el-button type="primary" @click="handleBatchEdit">确定</el-button>
        </div>
    </el-dialog>
    <!-- 上传修改弹窗 -->
    <el-dialog title="上传修改" :visible.sync="uploadVisible" width="500px" top="10px">
        <div class="upload-container">
            <div class="upload-tip">
                <p>请上传包含以下字段的Excel文件：</p>
                <ul>
                    <li><strong>生产编码(sccode)</strong> 或 <strong>配件id(goods_id)</strong> - 必填，用于匹配数据</li>
                    <li><strong>上海到货时间(book_down_time)</strong> - 可选，格式：2026-05-29 08:00:00，为空则不修改</li>
                    <li><strong>丹阳到货时间(delivery_time)</strong> - 可选，格式：2026-05-29 08:00:00，为空则不修改</li>
                </ul>
            </div>
            <div class="upload-area" @click="triggerFileInput" @dragover.prevent @drop.prevent="handleDrop">
                <input 
                    ref="fileInput" 
                    type="file" 
                    accept=".xlsx,.xls" 
                    class="file-input" 
                    @change="handleFileChange"
                />
                <i class="fa fa-upload" aria-hidden="true"></i>
                <p>点击或拖拽文件到此处上传</p>
                <!-- <p class="hint">支持 .xlsx, .xls 格式</p> -->
            </div>
            <div v-if="uploadedFileName" class="file-info">
                <span>已选择文件：{{ uploadedFileName }}</span>
            </div>
            <div v-if="previewData.length > 0" class="preview-box">
                <p class="preview-title">预览数据（前5条）</p>
                <el-table :data="previewData" border :show-header="true">
                    <el-table-column prop="sccode" label="生产编码"></el-table-column>
                    <el-table-column prop="goods_id" label="配件ID"></el-table-column>
                    <el-table-column prop="book_down_time" label="上海到货时间"></el-table-column>
                    <el-table-column prop="delivery_time" label="丹阳到货时间"></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <span :class="scope.row.status === 'success' ? 'status-success' : 'status-error'">
                                {{ scope.row.status === 'success' ? '有效' : '缺少关键字段' }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="uploadVisible = false; resetUpload()">取消</el-button>
            <el-button 
                type="primary" 
                @click="handleUpload" 
                :disabled="previewData.length === 0 || !hasValidData"
            >
                确定上传
            </el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import * as XLSX from 'xlsx'
import { export_json_to_excel } from "../../common/utils/Export2Excel"
export default {
    data() {
        return {
            tabState: 'deferred',
            searchData: {
                member_name: '',
                store_name: '',
                sccode: '',
                oecode: ''
            },
            urgeList: [],
            total: 0,
            currentPage: 1,
            pageSize: 20,
            checkAll: false,
            isIndeterminate: false,
            batchEditVisible: false,
            batchForm: {
                book_down_time: '',
                delivery_time: ''
            },
            // 上传相关
            uploadVisible: false,
            uploadedFileName: '',
            previewData: [],
            rawExcelData: []
        };
    },
    computed: {
        hasValidData() {
            return this.previewData.some(item => item.status === 'success');
        }
    },
    methods: {
        switchTab(state) {
            this.tabState = state;
            this.currentPage = 1;
            this.checkAll = false;
            this.isIndeterminate = false;
            if (state === 'urge') {
                this.getUrgeList({});
            } else {
                this.getDeferredList({});
            }
        },

        formatTimeValue(timeStr) {
            if (!timeStr) return '';
            if (timeStr.length === 10) {
                return timeStr + ' 08:00:00';
            }
            return timeStr;
        },

        async getUrgeList(params = {}) {
            try {
                let searParams = {
                    curpage: this.currentPage,
                    page: this.pageSize,
                    ...params
                };
                
                let res = await this.$api.select_goods_urge(searParams);
                
                if (res && res.list) {
                    this.urgeList = res.list.map(item => {
                        return {
                            ...item,
                            checked: false,
                            book_down_time: this.formatTimeValue(item.book_down_time),
                            delivery_time: this.formatTimeValue(item.delivery_time)
                        };
                    });
                    this.total = Number(res.total) || 0;
                } else {
                    this.urgeList = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('获取催交列表失败:', error);
                this.$message.error('获取催交列表失败');
            }
        },

        async getDeferredList(params = {}) {
            try {
                let searParams = {
                    store_curpage: this.currentPage,
                    store_page: this.pageSize,
                    arrived_state: '3',
                    ...params
                };
                
                let res = await this.$api.getArrivedTodaySearch(searParams);
                
                if (res.data && res.data[0] && res.data[0].goods_list) {
                    this.urgeList = res.data[0].goods_list.map(item => {
                        return {
                            ...item,
                            checked: false,
                            book_down_time: this.formatTimeValue(item.book_down_time),
                            delivery_time: this.formatTimeValue(item.delivery_time),
                            addtime: item.addtime || ''
                        };
                    });
                    this.total = Number(res.data[0].total) || 0;
                } else {
                    this.urgeList = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('获取延期列表失败:', error);
                this.$message.error('获取延期列表失败');
            }
        },

        handleCheckAllChange(val) {
            this.urgeList.forEach(item => {
                item.checked = val;
            });
            this.isIndeterminate = false;
        },

        handleItemCheck() {
            const checkedCount = this.urgeList.filter(item => item.checked).length;
            this.checkAll = checkedCount === this.urgeList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.urgeList.length;
        },

        showBatchEdit() {
            const selectedItems = this.urgeList.filter(item => item.checked);
            if (selectedItems.length === 0) {
                this.$message.warning('请先选择要修改的行');
                return;
            }
            this.batchForm = {
                book_down_time: '',
                delivery_time: ''
            };
            this.batchEditVisible = true;
        },

        async handleBatchEdit() {
            const selectedItems = this.urgeList.filter(item => item.checked);
            
            const updateFields = [];
            const updateData = selectedItems.map(item => {
                const dataItem = { goods_id: item.goods_id };
                if (this.batchForm.book_down_time) {
                    dataItem.book_down_time = this.batchForm.book_down_time;
                    if (!updateFields.includes('book_down_time')) {
                        updateFields.push('book_down_time');
                    }
                }
                if (this.batchForm.delivery_time) {
                    dataItem.delivery_time = this.batchForm.delivery_time;
                    if (!updateFields.includes('delivery_time')) {
                        updateFields.push('delivery_time');
                    }
                }
                return dataItem;
            });
            
            if (updateFields.length === 0) {
                this.$message.warning('请选择要修改的字段');
                return;
            }
            
            try {
                let res = await this.$api.setCommonData({
                    table: 'goods',
                    condition_fields: ['goods_id'],
                    update_fields: updateFields,
                    data: updateData
                });
                this.$suMsg('批量更新成功');
                this.batchEditVisible = false;
                this.checkAll = false;
                this.isIndeterminate = false;
                if (this.tabState === 'urge') {
                    this.getUrgeList({});
                } else {
                    this.getDeferredList({});
                }
            } catch (error) {
                console.error('批量更新失败:', error);
                this.$message.error('批量更新失败');
            }
        },

        handleBookDownTimeBlur(item) {
            const book_down_time = item.book_down_time;
            if (!book_down_time) return;
            this.$api.setCommonData({
                table: 'goods',
                condition_fields: ['goods_id'],
                update_fields: ['book_down_time'],
                data: [{ goods_id: item.goods_id, book_down_time }]
            }).then(() => {
                this.$suMsg('更新成功');
            }).catch(() => {
                this.$message.error('更新失败');
            });
        },

        handleDeliveryTimeBlur(item) {
            const delivery_time = item.delivery_time;
            if (!delivery_time) return;
            this.$api.setCommonData({
                table: 'goods',
                condition_fields: ['goods_id'],
                update_fields: ['delivery_time'],
                data: [{ goods_id: item.goods_id, delivery_time }]
            }).then(() => {
                this.$suMsg('更新成功');
            }).catch(() => {
                this.$message.error('更新失败');
            });
        },
        
        onSubmit() {
            this.currentPage = 1;
            if (this.tabState === 'urge') {
                this.getUrgeList({
                    member_name: this.searchData.member_name,
                    store_name: this.searchData.store_name,
                    sccode: this.searchData.sccode,
                    oecode: this.searchData.oecode
                });
            } else {
                this.getDeferredList({
                    search: this.searchData.sccode || this.searchData.oecode || this.searchData.store_name
                });
            }
        },
        
        clearSearch() {
            this.searchData = {
                member_name: '',
                store_name: '',
                sccode: '',
                oecode: ''
            };
            this.currentPage = 1;
            if (this.tabState === 'urge') {
                this.getUrgeList({});
            } else {
                this.getDeferredList({});
            }
        },
        
        handleCurrentChange(val) {
            this.currentPage = val;
            if (this.tabState === 'urge') {
                this.getUrgeList({
                    member_name: this.searchData.member_name,
                    store_name: this.searchData.store_name,
                    sccode: this.searchData.sccode,
                    oecode: this.searchData.oecode
                });
            } else {
                this.getDeferredList({
                    search: this.searchData.sccode || this.searchData.oecode || this.searchData.store_name
                });
            }
        },
        
        // 上传修改相关方法
        showUploadModal() {
            this.uploadVisible = true;
            this.resetUpload();
        },
        
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        
        handleDrop(e) {
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.processFile(files[0]);
            }
        },
        
        handleFileChange(e) {
            const files = e.target.files;
            if (files.length > 0) {
                this.processFile(files[0]);
            }
        },
        
        async processFile(file) {
            const fileName = file.name;
            const ext = fileName.split('.').pop().toLowerCase();
            
            if (ext !== 'xlsx' && ext !== 'xls') {
                this.$message.error('请上传Excel文件（.xlsx 或 .xls 格式）');
                return;
            }
            
            this.uploadedFileName = fileName;
            
            try {
                const data = await this.parseExcel(file);
                this.rawExcelData = data;
                this.generatePreview(data);
            } catch (error) {
                console.error('解析Excel失败:', error);
                this.$message.error('解析Excel文件失败');
            }
        },
        
        parseExcel(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        
                        if (jsonData.length < 2) {
                            reject(new Error('Excel文件内容为空或格式不正确'));
                            return;
                        }
                        
                        // 获取表头
                        const headers = jsonData[0].map(header => {
                            const h = String(header || '').trim().toLowerCase();
                            // 支持多种表头名称
                            if (h.includes('生产编码') || h === 'sccode') return 'sccode';
                            if (h.includes('配件id') || h.includes('配件id') || h === 'goods_id' || h === 'goodsid') return 'goods_id';
                            if (h.includes('上海') || h.includes('book_down') || h === 'book_down_time') return 'book_down_time';
                            if (h.includes('丹阳') || h.includes('delivery') || h === 'delivery_time') return 'delivery_time';
                            return h;
                        });
                        
                        // 解析数据行
                        const result = [];
                        for (let i = 1; i < jsonData.length; i++) {
                            const row = jsonData[i];
                            const item = {};
                            row.forEach((cell, index) => {
                                item[headers[index]] = cell;
                            });
                            // 处理空字符串
                            item.sccode = String(item.sccode || '').trim();
                            item.goods_id = String(item.goods_id || '').trim();
                            item.book_down_time = this.formatTimeValue(String(item.book_down_time || '').trim());
                            item.delivery_time = this.formatTimeValue(String(item.delivery_time || '').trim());
                            
                            if (item.sccode || item.goods_id) {
                                result.push(item);
                            }
                        }
                        resolve(result);
                    } catch (error) {
                        reject(error);
                    }
                };
                
                reader.onerror = () => {
                    reject(new Error('读取文件失败'));
                };
                
                reader.readAsArrayBuffer(file);
            });
        },
        
        generatePreview(data) {
            this.previewData = data.slice(0, 5).map(item => ({
                ...item,
                status: item.sccode || item.goods_id ? 'success' : 'error'
            }));
        },
        
        async handleUpload() {
            const validData = this.rawExcelData.filter(item => item.sccode || item.goods_id);
            
            if (validData.length === 0) {
                this.$message.warning('没有有效的数据');
                return;
            }
            
            try {
                // 收集所有需要更新的字段
                const updateFields = [];
                if (validData.some(item => item.book_down_time)) {
                    updateFields.push('book_down_time');
                }
                if (validData.some(item => item.delivery_time)) {
                    updateFields.push('delivery_time');
                }
                
                if (updateFields.length === 0) {
                    this.$message.warning('没有需要更新的字段');
                    return;
                }
                
                // 构建批量更新数据
                const updateData = validData.map(item => {
                    const dataItem = { store_id: 1780 };
                    if (item.goods_id) {
                        dataItem.goods_id = item.goods_id;
                    }
                    if (item.sccode) {
                        dataItem.sccode = item.sccode;
                    }
                    if (item.book_down_time) {
                        dataItem.book_down_time = item.book_down_time;
                    }
                    if (item.delivery_time) {
                        dataItem.delivery_time = item.delivery_time;
                    }
                    return dataItem;
                });
                
                // 判断使用哪个条件字段
                const hasGoodsId = validData.some(item => item.goods_id);
                const hasSccode = validData.some(item => item.sccode);
                
                let conditionFields = ["store_id"];
                if (hasGoodsId) conditionFields.push('goods_id');
                if (hasSccode) conditionFields.push('sccode');
                
                // 调用批量更新接口
                const res = await this.$api.setCommonData({
                    table: 'goods',
                    condition_fields: conditionFields,
                    update_fields: updateFields,
                    data: updateData
                });
                
                if (res) {
                    this.$suMsg('批量更新成功');
                    this.uploadVisible = false;
                    this.resetUpload();
                    if (this.tabState === 'urge') {
                        this.getUrgeList({});
                    } else {
                        this.getDeferredList({});
                    }
                } else {
                    this.$message.error(res.msg || '更新失败');
                }
            } catch (error) {
                console.error('上传更新失败:', error);
                this.$message.error('上传更新失败');
            }
        },
        
        resetUpload() {
            this.uploadedFileName = '';
            this.previewData = [];
            this.rawExcelData = [];
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        async handleExport() {
            let exportList = [];
            const selectedItems = this.urgeList.filter(item => item.checked);

            if (selectedItems.length > 0) {
                exportList = selectedItems;
            } else {
                try {
                    if (this.tabState === 'urge') {
                        const res = await this.$api.select_goods_urge({
                            curpage: 1,
                            page: this.total > 0 ? this.total : 1000,
                            ...this.searchData
                        });
                        if (res && res.list) {
                            exportList = res.list.map(item => {
                                const { deferred_note, arrivalTime } = this.parseDeferredData(item);
                                return { ...item, deferred_note, arrivalTime };
                            });
                        }
                    } else {
                        const res = await this.$api.getArrivedTodaySearch({
                            store_curpage: 1,
                            store_page: this.total > 0 ? this.total : 1000,
                            arrived_state: '3',
                            search: this.searchData.sccode || this.searchData.oecode || this.searchData.store_name
                        });
                        if (res.data && res.data[0] && res.data[0].goods_list) {
                            exportList = res.data[0].goods_list.map(item => {
                                const { deferred_note, arrivalTime } = this.parseDeferredData(item);
                                return { ...item, deferred_note, arrivalTime };
                            });
                        }
                    }
                } catch (error) {
                    console.error('获取导出数据失败:', error);
                    this.$message.error('获取导出数据失败');
                    return;
                }
            }

            if (exportList.length === 0) {
                this.$message.warning('没有可导出的数据');
                return;
            }

            const tHeader = ['生产编码', '配件id', 'OE号', '上海到货时间', '丹阳到货时间'];
            const filterVal = ['sccode', 'goods_id', 'oecode', 'book_down_time', 'delivery_time'];
            const data = this.formatJson(filterVal, exportList);
            const filename = this.tabState === 'urge' ? '催交列表' : '延期列表';

            export_json_to_excel({
                header: tHeader,
                data,
                filename,
                autoWidth: true,
                bookType: 'xlsx'
            });
        },

        formatJson(filterVal, tableData) {
            return tableData.map(v => {
                return filterVal.map(j => {
                    return v[j] || '';
                });
            });
        }
        // 上传修改相关方法结束
    },
    created() {
        // this.getUrgeList({});
        this.getDeferredList({});
    }
};
</script>

<style lang="scss">
.el-dialog__body {
    padding: 0;
}
.arrival-admin {
    padding: 20px;
    background: #f5f5f5;
    min-height: 100%;
    width: 100%;
    .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e4e4;
    }
    
    .tab-header {
        display: flex;
        margin-bottom: 15px;
        
        .tab-item {
            padding: 8px 20px;
            background: #fff;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            font-size: 14px;
            color: #666;
            transition: all 0.3s;
            
            &.active {
                background: #409eff;
                color: #fff;
            }
            
            &:hover {
                background: #e8f4fc;
            }
            
            &.active:hover {
                background: #409eff;
            }
        }
    }
    
    .search-box {
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        margin-bottom: 15px;
        
        .el-form-item {
            margin-bottom: 0;
        }
        
        .el-input {
            width: 100px;
        }
    }
    
    .batch-btn-box {
        margin-bottom: 15px;
        
        .el-button {
            margin-right: 10px;
        }
    }
    
    .urge-table {
        background: #fff;
        border-radius: 4px;
        width: 100%;
        .table-head {
            display: flex;
            background: #c4c9cc;
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
            
            > div {
                text-align: center;
                font-size: 14px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .checkbox { width: 40px; }
            .index { width: 40px; }
            .member_name { width: 80px; }
            .store_name { width: 100px; }
            .goods_name { flex: 1; min-width: 100px; }
            .sccode { width: 90px; }
            .oecode { width: 90px; }
            .oenaturebrand { width: 70px; }
            .arrived_state { width: 70px; }
            .add_time { width: 180px; }
        }
        
        .table-body {
            .table-row {
                display: flex;
                padding: 0 10px;
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #e4e4e4;
                
                // &:nth-child(2n) {
                //     background: #f7f7f7;
                // }
                
                > div {
                    text-align: center;
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                
                .checkbox { width: 40px; display: flex; align-items: center; justify-content: center; }
                .index { width: 40px; }
                .member_name { width: 80px; }
                .store_name { width: 100px; }
                .goods_name { 
                    flex: 1; 
                    min-width: 100px; 
                }
                .sccode { width: 90px; }
                .oecode { width: 90px; }
                .oenaturebrand { width: 70px; }
                .arrived_state { width: 70px; }
                .add_time { 
                    width: 180px; 
                    .el-date-editor {
                        width: 174px;
                    } 
                }
            }
            
            .no-data {
                text-align: center;
                padding: 50px 0;
                color: #999;
                font-size: 14px;
            }
        }
    }
    
    .pagination-box {
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        margin-top: 15px;
        text-align: right;
    }
    
    /* 上传弹窗样式 */
    .upload-container {
        padding: 10px;
        
        .upload-tip {
            margin-bottom: 15px;
            padding: 10px;
            background: #f5f7fa;
            border-radius: 4px;
            
            p {
                margin-bottom: 8px;
                font-size: 14px;
                color: #666;
            }
            
            ul {
                margin: 0;
                padding-left: 20px;
                
                li {
                    font-size: 13px;
                    color: #888;
                    margin-bottom: 4px;
                }
            }
        }
        
        .upload-area {
            border: 2px dashed #d9d9d9;
            border-radius: 6px;
            padding: 30px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;
            
            &:hover {
                border-color: #409eff;
                background: #f0f7ff;
            }
            
            .fa-upload {
                font-size: 36px;
                color: #c0c4cc;
                margin-bottom: 10px;
            }
            
            p {
                margin: 0 0 5px 0;
                font-size: 14px;
                color: #666;
                
                &.hint {
                    font-size: 12px;
                    color: #999;
                }
            }
            
            .file-input {
                display: none;
            }
        }
        
        .file-info {
            margin-top: 10px;
            padding: 10px;
            background: #f0f7ff;
            border-radius: 4px;
            font-size: 13px;
            color: #409eff;
        }
        
        .preview-box {
            margin-top: 15px;
            
            .preview-title {
                font-size: 14px;
                font-weight: bold;
                color: #333;
                margin-bottom: 10px;
            }
            
            .el-table {
                font-size: 12px;
                
                .status-success {
                    color: #67c23a;
                }
                
                .status-error {
                    color: #f56c6c;
                }
            }
        }
    }
}
</style>
